<app-styleguide-specimen [rendering]="rendering" e2eId="styleguide-sitecore-context">
    <p>The current Sitecore Context has been logged to the console.</p>
</app-styleguide-specimen>
